import { RefObject, useEffect, useRef } from "react";
import { setScrollTop } from "~/utils/dom-helpers";
import { elementPositionInContainer } from "~/utils/dom-helpers";
import { IListRef } from "./List";
import { useUnmount } from "react-use";

export function focusLastListEntry<T>(listRef: RefObject<IListRef<T>>) {
  const lastEntry = listRef.current?.entries.at(-1);

  if (!lastEntry) return;

  lastEntry.node.focus({ preventScroll: true });

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const scrollboxEl = lastEntry.scrollboxContext.scrollboxRef.current!;

  const { bottom } = elementPositionInContainer({
    container: scrollboxEl,
    element: lastEntry.node,
    containerPosOffset: {
      top: lastEntry.scrollboxContext.offsetHeaderEl?.current?.offsetHeight,
    },
  });

  if (bottom !== "above") return;

  setScrollTop(scrollboxEl, (oldValue) => oldValue - 100);
}

/* -----------------------------------------------------------------------------------------------*/

export function useFocusFirstEntryOnQueryChange(props: { listRef: React.RefObject<IListRef<unknown>>; query: string }) {
  const isMountedRef = useRef(true);

  useUnmount(() => {
    isMountedRef.current = false;
  });

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!isMountedRef.current) return;
      const list = props.listRef.current;
      if (!list) return;

      const entries = list.entries || [];
      const firstEntryId = entries[0]?.id;
      if (!firstEntryId) return;

      list.focus(firstEntryId);
    }, 10);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [props.query, props.listRef]);
}

/* -----------------------------------------------------------------------------------------------*/
